<script lang="ts">
	//Formatters
	import { format } from 'svelte-i18n';
	//Helpers
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { getTemplateService } from 'src/helpers/xt1_helpers/template_helpers';
	//Services
	import { gen2Request } from 'src/services/gen_2_http_reqs';
	//Stores
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Design system components
	import { Text, Select, Button } from '@Shelly/shelly-design-system';
	//Types
	import type { SelectOptionPropsType } from '@Shelly/shelly-design-system';
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	import type { Device } from 'src/types/Device';

	export let device: Device,
		options: SelectOptionPropsType[] = [],
		property: string,
		icon: string = 'fas fa-list',
		sub_title: string = '';

	let waitForResponse = false;
	let targetLock = false;
	let value: string = options[0].value as string;

	const onSettingChange = (device: Device) => {
		const _value = getTemplateService(device)?.settings?.[property] || options[0];
		if (!waitForResponse && !targetLock && value !== _value) {
			value = _value;
		}
		if (targetLock && value == _value) {
			targetLock = false;
		}
	};

	const saveValue = async () => {
		waitForResponse = true;
		const _value = value;
		const res: SettingRequest = await gen2Request(device, 'Service.SetConfig', {
			id: 0,
			config: {
				[`${property}`]: value,
			},
		});
		if (res?.isok) {
			targetLock = true;
			value = _value;
		}
		onSettingsResponse(res, device);
		waitForResponse = false;
	};

	$: settingsStore = getDeviceSettings(device.id);
	$: (onSettingChange(device), $settingsStore);
</script>

{#if sub_title}
	<Text styleType="body-small" class="mb-s">
		{sub_title}
	</Text>
{/if}
<Select
	aria-label={$format('select_action', { default: 'Select Action' })}
	{options}
	value={options.find((i) => i.value == value) || options[0]}
	{icon}
	size="m"
	class="mb-s"
	on:change={(e) => {
		value = e.detail['value'];
	}}
	id="select-zjpx3hq"
/>
<Button width="full" size="m" on:click={saveValue} loading={waitForResponse}
	>{$format('button_save', { default: 'Save' })}</Button
>
